import React from 'react';
import PropTypes from 'prop-types';
import DataPrivacy from './DataPrivacy';
import ChooseLanguageWrapper from './ChooseLanguageWrapper';
import Connector from '../../agent';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { useTranslation, withTranslation } from 'react-i18next';
import { Menu, Icon, Popup } from 'semantic-ui-react';
import { userType } from '../../types/index';
import { commonActions } from '../../behavior/common/index';
import { useTitleState } from '../TitleContextProvider';
import { VersionComponent } from 'react-lib/dist/components-es';
import { LOGO_IMAGE_PATH } from '../../constants';
import { initSelectors } from '../../behavior/init';
import keycloak from '../../keycloak';
import useUser from '@behavior/init/getUserV2';

type Props = {
  showPersonalData: boolean;
  onToggleSidebar: () => void;
};

const HeaderComponent = ({ onToggleSidebar, showPersonalData }: Props) => {
  const { t } = useTranslation();
  const { user } = useUser();
  const titleState = useTitleState();
  const { apiConfig } = Connector;
  return (
    <Menu inverted borderless size="huge" fixed="top" fluid id="app-main-navbar">
      <Menu.Item icon="sidebar" size="large" onClick={() => onToggleSidebar()} />
      <Menu.Item header icon id="headerCeresLogo">
        <img alt="CERES logo" src={LOGO_IMAGE_PATH} />
      </Menu.Item>
      <Menu.Item header className="headerPageContainer">
        <>
          CERES
          {window.REACT_APP_HEADER_SUFFIX && (
            <span style={{ color: 'red' }}>{window.REACT_APP_HEADER_SUFFIX}</span>
          )}
          <VersionComponent axiosConfig={apiConfig} />
          {titleState ? <Icon name={'angle right'} style={{ margin: '0 10px 0 10px' }} /> : null}
          <div className="headerPageTitle">{titleState.pageTitle}</div>
        </>
      </Menu.Item>
      <Menu.Menu position="right">
        <Menu.Item>{initSelectors.isHseDeveloper(user) && <DataPrivacy />}</Menu.Item>
        <Menu.Item>
          <ChooseLanguageWrapper />
        </Menu.Item>
        {user ? (
          <>
            <Popup
              key="userRolesToolTip"
              className="userRoles"
              trigger={
                <Menu.Item>
                  <Icon name="user" />
                  {showPersonalData
                    ? user.personId > 0
                      ? typeof user.username !== 'undefined'
                        ? String(user.username).toLowerCase()
                        : ''
                      : String(user.email)
                    : 'xxxxxx'}
                </Menu.Item>
              }
              size="mini"
              position="bottom right"
            >
              <p>{'Roles:'}</p>
              {user.authorities && user.authorities.length > 0
                ? user.authorities
                    .filter(
                      authority =>
                        user.authorities.length === 1 || authority.authority !== 'ROLE_PUB'
                    )
                    .map(authority => (
                      // RRA-1068 In theory we should distinguish between departments for ROLE_EDT (e.g., editor-hse & editor-be),
                      // ceres does not support this directly, however necessary data is accessible in the backend from egroups
                      <p key={`roleKey-${authority.authority}`}>{t(authority.authority)}</p>
                    ))
                : null}
            </Popup>
            <Menu.Item
              as="a"
              key="helpPageMenuItem"
              target="_blank"
              href={window.REACT_APP_HELP_PAGE_URL}
            >
              <Icon name="question" />
              {t('header.help')}
            </Menu.Item>
            <Menu.Item as="a" key="logOutMenuItem" onClick={() => keycloak?.logout()}>
              <Icon name="sign-out" />
              {t('header.log.out')}
            </Menu.Item>
          </>
        ) : (
          <span>{t('header.not.connected')}</span>
        )}
      </Menu.Menu>
    </Menu>
  );
};

HeaderComponent.propTypes = {
  onToggleSidebar: PropTypes.func.isRequired,
  user: userType.isRequired,
};
const mapStateToProps = (state: any) => ({
  showPersonalData: state.dataPrivacy.showPersonalData,
});

const mapDispatchToProps = (dispatch: any) => ({
  onToggleSidebar: () => dispatch(commonActions.toggleSidebar()),
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(HeaderComponent);
